module.exports = __webpack_public_path__ + "images/charity6.d46b8c1e.svg";